import { render, staticRenderFns } from "./WhatsappEnrichmentTermsOfUse.vue?vue&type=template&id=cb660bae&scoped=true&"
import script from "./WhatsappEnrichmentTermsOfUse.vue?vue&type=script&lang=ts&"
export * from "./WhatsappEnrichmentTermsOfUse.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsappEnrichmentTermsOfUse.vue?vue&type=style&index=0&id=cb660bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb660bae",
  null
  
)

export default component.exports